import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { IdInterface, SelectedProductInterface } from '../data';
import { OperationProvider } from '../providers/operation.provider';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface CreateOperationUseCaseParams {
    selectedProductId: IdInterface;
    onlyRefund?: boolean;
    editing?: boolean;
    readonly?: boolean;
    clientCode?: IdInterface;
}

@Injectable()
export class CreateOperationUseCase implements UseCaseWithParam<CreateOperationUseCaseParams, Observable<Transaction<void>>> {
    constructor(
        private contractProvider: ContractProvider,
        private operationProvider: OperationProvider,
        private productProvider: ProductProvider
    ) {}

    bind(params: CreateOperationUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) =>
                        this.productProvider.findSelected(contract.encryptedCode, params.clientCode).pipe(
                            switchMap((transactionSelectedProduct) =>
                                transactionSelectedProduct.map(
                                    (selectedProducts) => {
                                        let selectedProduct: SelectedProductInterface;
                                        selectedProducts.map((it) => {
                                            if (it.id.value === params.selectedProductId.value) {
                                                selectedProduct = it;
                                            }
                                        });

                                        if (selectedProduct) {
                                            return this.productProvider.detail(selectedProduct.encryptedCode).pipe(
                                                switchMap((transactionProduct) =>
                                                    transactionProduct.map(
                                                        (product) =>
                                                            this.operationProvider.create(
                                                                contract,
                                                                product,
                                                                selectedProduct,
                                                                params.onlyRefund || false,
                                                                params.editing || false,
                                                                params.readonly || false,
                                                                params.clientCode
                                                            ),
                                                        (throwable) => of(Transaction.error(throwable.message))
                                                    )
                                                )
                                            );
                                        }

                                        return of(Transaction.error<void>());
                                    },
                                    (throwable) => of(Transaction.error(throwable.message))
                                )
                            )
                        ),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
